<template>
	<div class="container-fluid">
		<listado-filtro :filtro="filtro" @buscar="buscar" @nuevo="idAnunciante = 'nuevo'"></listado-filtro>

		<div class="card text-left mt-3" v-if="resultados.length > 0">
			<div class="card-header">
				{{ resultados.length }} resultados
			</div>

			<div class="table-responsive text-left">
				<table class="table table-striped table-condensed">
					<thead class="bg-dark text-white">
						<tr>
							<th>ID</th>
							<th>Agente</th>
							<th>Anunciante</th>
							<th>Campañas</th>
							<th>Opciones</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="anunciante in resultados" :key="anunciante.ID_anunciante">
							<td>{{ anunciante.ID_anunciante }}</td>
							<td>{{ anunciante.agenteNombre }}</td>
							<td>{{ anunciante.nombre }}</td>
							<td>{{ anunciante.campanas }}</td>
							<td>
								<button class="btn btn-sm btn-primary" @click="idAnunciante = anunciante.ID_anunciante">
									<span class="fa fa-eye"></span>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div v-if="resultados.length === 0" style="text-align:center;padding-top:20px;font-size:2em;font-weight:bold;" class="mt-3 text-danger">
			<span class="fa fa-ban"></span>
			<br>
			No hay resultados
		</div>
		<editor-anunciante :id-anunciante="idAnunciante" v-if="idAnunciante" @cerrar="idAnunciante = null"></editor-anunciante>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'
import Filtro from './listado-filtro'
import Editor from '../editor/editor'
import API from '../../services/api'

export default {
	components: {
		'listado-filtro': Filtro,
		'editor-anunciante': Editor
	},
	data: function () {
		return {
			filtro: {
				semaforo: null,
				agente: '',
				nombre: '',
				activo: null,
				bloqueado: null,
				facturacion: null,
				max: 50
			},
			resultados: [],
			idAnunciante: null
		}
	},

	created () {
		this.buscar()
	},

	computed: {
		...mapGetters({
			session: 'session/usuario'
		})
	},

	methods: {
		buscar () {
			API.buscar(this.filtro)
				.then(res => {
					this.resultados = res.data.resultados
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error realizando la búsqueda'
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-anunciantes/vue/components/listado/listado.vue